<template>
  <div class="px-3 pb-3">
    <b-row>
      <b-col sm="8">
        <b-input-group class="search-order panel-input-serach date-box">
          <b-form-input
            id="product-search"
            class="input-serach"
            placeholder="ค้นหาหมายเลขรายการ"
            @keypress="handlePushMessage"
            v-model="filter.keyword"
          ></b-form-input>
          <b-input-group-prepend>
            <span class="icon-input m-auto pr-2">
              <font-awesome-icon
                icon="search"
                title="View"
                @click="getOrderList"
              />
            </span>
          </b-input-group-prepend>
        </b-input-group>
      </b-col>
      <b-col sm="4" class="mt-3 pl-0 text-center">
        <b-button class="mt-3 btn-clear-filter" @click="clearFilter"
          >ล้างตัวกรอง</b-button
        >
        <b-button class="mt-3 ml-2 btn-purple" @click="getOrderList"
          >ค้นหา</b-button
        >
      </b-col>
      <b-col sm="6" class="mt-3">
        <div class="font-weight-bold mb-2">
          วันที่ทำรายการ (เริ่มต้น)
        </div>
        <div :class="['input-container date-box']">
          <datetime
            :input-style="styleDatetime"
            v-model="filter.startDate"
            placeholder="วว / ดด / ปป"
            ref="startDate"
            format="dd/MM/yyyy"
            value-zone="Asia/Bangkok"
            @close="changeStartDate"
          >
          </datetime>
          <div
            class="icon-container text-right"
            @click="$refs.startDate.isOpen = true"
          >
            <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
          </div>
        </div>
      </b-col>
      <b-col sm="6" class="mt-3">
        <div class="font-weight-bold mb-2">
          วันที่ทำรายการ (สิ้นสุด)
        </div>
        <div :class="['input-container date-box']">
          <datetime
            :input-style="styleDatetime"
            v-model="filter.endDate"
            placeholder="วว / ดด / ปป"
            ref="endDate"
            format="dd/MM/yyyy"
            value-zone="Asia/Bangkok"
            :min-datetime="filter.startDate"
            @close="onChangeEndDate"
          >
          </datetime>
          <div
            class="icon-container text-right"
            @click="$refs.endDate.isOpen = true"
          >
            <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="8" class="text-table">
        <b-table
          responsive
          :thead-tr-class="thTableProduct"
          :tbody-tr-class="trTableProduct"
          class="mt-3 text-center table-list"
          :fields="fields"
          :items="orderList"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:head(orderId)="">
            <b-form-checkbox
              size="lg"
              class="ml-3"
              id="order-time-cb-all"
              name="orderTimeCbAll"
              v-model="selectAllTable"
              @change="checkOrderHeader"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(orderId)="data">
            <b-form-checkbox
              size="lg"
              class="ml-3"
              :value="data.item"
              v-model="form.orderSelectList"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(systemInvoiceNo)="data">
            <div v-if="data.item.systemInvoiceNo" class="text-table">
              <p class="m-0">{{ data.item.systemInvoiceNo }}</p>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(invoiceNo)="data">
            <div v-if="data.item.invoiceNo" class="text-table">
              <p class="m-0">{{ data.item.invoiceNo }}</p>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(createdTime)="data">
            <div class="date-text" v-if="data.item.createdTime">
              {{ new Date(data.item.createdTime) | moment($formatDateTime) }}
            </div>
            <div class="date-text" v-else>-</div>
          </template>
          <template v-slot:cell(paymentTime)="data">
            <div class="date-text" v-if="data.item.paymentTime">
              {{ new Date(data.item.paymentTime) | moment($formatDateTime) }}
            </div>
            <div class="date-text" v-else>-</div>
          </template>
          <template v-slot:cell(quantity)="data">
            <div class="stock-text" v-if="data.item.quantity">
              <p class="m-0">
                {{ data.item.quantity | numeral("0,0") }}
              </p>
            </div>
            <div v-else class="stock-text"><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(grandTotal)="data">
            <p class="m-0 price-text" v-if="data.item.grandTotal">
              ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
            </p>
            <p v-else class="m-0 price-text">-</p>
          </template>
        </b-table>

        <b-row class="px-3 pb-3">
          <b-col sm="12" class="form-inline justify-content-end">
            <div class="d-sm-flex mr-3">
              <b-pagination
                v-model="filter.Page"
                :total-rows="rows"
                :per-page="filter.Take"
                class="m-md-0 page-item"
                @change="pagination"
              ></b-pagination>
            </div>
            <b-form-select
              v-model="filter.Take"
              @change="hanndleChangePerpage"
              class="pagination-table"
              :options="pageOptions"
            ></b-form-select>
          </b-col>
          <b-col sm="12" class="mt-2 form-inline justify-content-end">
            <div v-if="v.orderSelectList.$error">
              <span class="text-error"
                >*กรุณาเลือกรายการอย่างน้อย 1 รายการ</span
              >
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="4" class="px-0 mt-3">
        <BillFinance :bill="bill" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import BillFinance from "../bill/BillPanel.vue";
export default {
  name: "FinanceOrderPanel",
  components: { InputText, BillFinance },
  props: {
    form: {
      type: Object,
      isRequired: true,
    },
    v: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      isBusy: false,
      orderList: [],
      filter: {
        keyword: "",
        startDate: "",
        endDate: "",
        Page: 1,
        Take: 10,
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      selectAllTable: false,
      fields: [
        {
          key: "orderId",
          label: ``,
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "5%",
          },
        },
        {
          key: "systemInvoiceNo",
          label: `หมายเลขคำสั่งซื้อระบบ`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "20%",
          },
        },
        {
          key: "invoiceNo",
          label: `หมายเลขคำสั่งซื้อ`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
        },
        {
          key: "createdTime",
          label: `วันที่สั่งซื้อ`,
          class: "px-1 text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
        },
        {
          key: "paymentTime",
          label: `วันที่ชำระเงิน`,
          class: "px-1 text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
        },
        {
          key: "quantity",
          label: `จำนวน`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
        },
        {
          key: "grandTotal",
          label: `ยอดสุทธิ`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
        },
      ],
      thTableProduct: {
        "border-bottom": "2px solid #f8f8f8 !important",
        "min-height": "80px !important",
      },
      trTableProduct: { "border-bottom": "2px solid #f8f8f8 !important" },
      styleDatetime: {
        width: "180%",
        border: "none",
      },
      bill: {
        orderCount: 0,
        subtotal: 0,
        shippingCost: 0,
        totalDiscount: 0,
        platformDiscount: 0,
        shopDiscount: 0,
        realShippingCost: 0,
        platformGP: 0,
        paymentFee: 0,
        paymentVATFee: 0,
        transferFee: 0,
        serviceCost: 0,
      },
    };
  },
  watch: {
    "form.orderSelectList": {
      handler(val) {
        this.selectAllTable =
          this.form.orderSelectList.length == this.orderList.length
            ? true
            : false;
        this.bill = {
          orderCount: this.form.orderSelectList.length,
          subtotal: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.subtotal,
            0
          ),
          shippingCost: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.shippingCost,
            0
          ),
          totalDiscount: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.discount,
            0
          ),
          platformDiscount: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.platformDiscount,
            0
          ),
          shopDiscount: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.shopDiscount,
            0
          ),
          realShippingCost: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.realShippingCost,
            0
          ),
          platformGP: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.platformGP,
            0
          ),
          paymentFee: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.paymentFee,
            0
          ),
          paymentVATFee: this.form.orderSelectList.reduce(
            (partialSum, a) => partialSum + a.paymentVATFee,
            0
          ),
          transferFee: this.bill.transferFee,
          serviceCost: this.bill.serviceCost,
        };
      },
    },
  },
  created: async function() {
    this.getOrderList();
    this.getOmiseServiceCharge();
  },
  methods: {
    getOrderList() {
      this.isBusy = true;
      this.form.orderSelectList = [];
      this.axios
        .post(`${this.$baseUrl}/statement/OrderList`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.orderList = data.detail.data;
            this.rows = data.detail.count;
            this.selectAllTable = false;
            this.isBusy = false;
          }
        });
    },
    getOmiseServiceCharge() {
      this.axios
        .get(`${this.$baseUrl}/statement/OmiseServiceCharge`)
        .then((data) => {
          if (data.result == 1) {
            this.bill.transferFee = data.detail.transferFee;
            this.bill.serviceCost = data.detail.serviceCost;
          }
        });
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.getOrderList();
      }
    },
    pagination(page) {
      this.filter.Page = page;
      this.getList();
    },
    hanndleChangePerpage(value) {
      this.filter.Page = 1;
      this.filter.Take = value;
      this.getList();
    },
    changeStartDate() {
      if (!this.filter.endDate || this.filter.startDate > this.filter.endDate) {
        this.filter.endDate = this.filter.startDate;
      }
    },
    onChangeEndDate() {
      if (!this.filter.startDate) {
        this.filter.startDate = this.filter.endDate;
      }
    },
    checkOrderHeader(value) {
      if (value) {
        this.form.orderSelectList = [];
        this.form.orderSelectList = this.orderList;
      } else {
        this.form.orderSelectList = [];
      }
    },
    clearFilter() {
      this.filter = {
        keyword: "",
        startDate: "",
        endDate: "",
        Page: 1,
        Take: 10,
      };
      this.rows = 0;
      this.getOrderList();
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.date-box {
  border-radius: 6px !important;
  border: 1px solid #bcbcbc !important;
}
.search-order {
  height: 42.2px;
  margin-top: 30px;
}
.text-table {
  font-size: 14px;
}
.btn-purple {
  width: 48%;
  height: 42.4px;
  color: #ffffff;
  background-color: #7160c4;
}
.btn-clear-filter {
  width: 48%;
  height: 42.4px;
  color: #7160c4;
  background-color: #ffffff;
  border: 1px solid #7160c4;
}
</style>
